var map = {
	"./ADA.svg": 1746,
	"./AUD.svg": 5916,
	"./BCH.svg": 1309,
	"./BTC.svg": 8459,
	"./CAD.svg": 5622,
	"./CHF.svg": 355,
	"./CNH.svg": 3787,
	"./CZK.svg": 9788,
	"./DKK.svg": 8276,
	"./DOG.svg": 84,
	"./DOT.svg": 1527,
	"./EOS.svg": 3697,
	"./ETH.svg": 5447,
	"./EUR.svg": 8254,
	"./GBP.svg": 1347,
	"./HKD.svg": 3343,
	"./HUF.svg": 891,
	"./ILS.svg": 2432,
	"./JPY.svg": 5645,
	"./LNK.svg": 7195,
	"./LTC.svg": 7285,
	"./MXN.svg": 2525,
	"./NOK.svg": 7798,
	"./NZD.svg": 2962,
	"./PLN.svg": 1004,
	"./RPL.svg": 5048,
	"./RUB.svg": 3385,
	"./SEK.svg": 7933,
	"./SGD.svg": 9812,
	"./TRY.svg": 2237,
	"./USD.svg": 9834,
	"./XAG.svg": 8958,
	"./XAU.svg": 5276,
	"./XCU.svg": 7638,
	"./XLM.svg": 8743,
	"./XRP.svg": 5787,
	"./ZAR.svg": 3621,
	"./none.jpg": 2340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3052;